import { render, staticRenderFns } from "./CategoryFilterList.vue?vue&type=template&id=64304daa&scoped=true&"
import script from "./CategoryFilterList.vue?vue&type=script&lang=js&"
export * from "./CategoryFilterList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilterList.vue?vue&type=style&index=0&id=64304daa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64304daa",
  null
  
)

export default component.exports